module.exports = __webpack_public_path__ + "img/25.3cfd24f5.jpg";